module.exports = __webpack_public_path__ + "img/Dr-Joseph-Angel.96ed5d45.png";